"use client";

import { faUserCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";

import logout from "@server/auth/logout";

interface Props {
  hiddenOnDesktop?: boolean;
  hiddenOnMobile?: boolean;
  variant?: "button";
}

export default function LogoutMenuItem({
  hiddenOnDesktop = false,
  hiddenOnMobile = true,
  variant,
}: Props) {
  return (
    <form action={logout}>
      <button
        className={clsx(
          "site-header__nav__menu__link",
          {
            "hidden-on-mobile": hiddenOnMobile,
            "hidden-on-desktop": hiddenOnDesktop,
            "site-header__nav__menu__link--is-button": variant === "button",
          },
        )}
        data-spec="site-header_log-out_button"
        role="menuitem"
        type="submit"
      >
        <FontAwesomeIcon
          className="site-header--financial-education__icon"
          icon={faUserCircle}
        />
        <div>Log Out</div>
      </button>
    </form>
  );
}
